import { Calculator } from '@dynameat/views/reporting/models/calculator';
import { DINER_MARGIN } from '../../constants';
import { OccupationQuery, TotalMarginQuery } from '../queries';

export class DinerMarginCalculator extends Calculator {
  kpiType = DINER_MARGIN;

  async calculateKPI() {
    const currentMarginResponse = await this.executeUncubeQuery(TotalMarginQuery, this.currentPeriod);
    const currentOccupationResponse = await this.executeUncubeQuery(OccupationQuery, this.currentPeriod);
    const currentDinerMargin = this.getDinerMargin(currentMarginResponse, currentOccupationResponse);
    let props;
    if (this.previousPeriod) {
      const previousMarginResponse = await this.executeUncubeQuery(TotalMarginQuery, this.previousPeriod);
      const previousOccupationResponse = await this.executeUncubeQuery(OccupationQuery, this.previousPeriod);
      const previousDinerMargin = this.getDinerMargin(previousMarginResponse, previousOccupationResponse);
      props = this.getData(currentDinerMargin, previousDinerMargin);
    } else props = this.getDataIfNoPreviousPeriod(currentDinerMargin);
    return this.getModelToInstance(props);
  }

  getDinerMargin(marginResponse, occupationResponse) {
    const rawMargin = this.getRawMargin(marginResponse.data.result[0][0], marginResponse.data.result[0][1]);
    const rawOccupation = occupationResponse.data.result[0][0];
    const dinerMargin = rawMargin / rawOccupation;
    return (rawOccupation !== 0) ? dinerMargin : null;
  }

  getRawMargin(rawTotalSalePrice, rawTotalCostPrice) {
    return rawTotalSalePrice - rawTotalCostPrice;
  }
}
